/* eslint-disable camelcase, class-methods-use-this */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

// const certFile = require('./shakealert_vernemq_ca.crt');

declare module 'react' {
  interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
    // extends React's HTMLAttributes
    style?: CSSProperties;
  }
}

const RegisterAPI = '/api/v1/schools/';
const OrderApi = '/api/v1/orders/';

const LinkOrder = () => {
  const history = useHistory();
  const [name, setName] = useState('');
  const [incomingOrder, setIncomingOrder] = useState('');
  const [order, setOrder] = useState(0);
  const [statusMessage, setStatusMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [createOrder, setCreateOrder] = useState(false);

  const getConfig = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    };
    return config;
  };

  const onSubmit = async (e: React.MouseEvent<HTMLButtonElement>, urlPath: string) => {
    e.preventDefault();
    const config = await getConfig();
    const orderNum = incomingOrder.replace(/\s+/g, '');
    const data = { order_number: orderNum };
    const id = urlPath.substring(6);
    try {
      const orderData = await axios.get(`${OrderApi}?order_number=${orderNum}`, config);
      if (orderData.data.count === 0) {
        setCreateOrder(true);
        return false;
      }
    } catch (err) {
      setCreateOrder(true);
      return false;
    }
    try {
      const res = await axios.post(`${RegisterAPI}add-order/${id}`, data, config);
      if (res.status === 200) {
        setMessageType('success');
        setStatusMessage('Site successfully linked');
        setOrder(res.data.organization.order);
        return true;
      }
      setMessageType('err');
      setStatusMessage('Error activating the organization. Ensure it is located in CA, OR, WA and please try again.');
      return false;
    } catch (err) {
      setMessageType('err');
      setStatusMessage('Error registering the organization. Ensure it is located in CA, OR, WA and please try again.');
      return false;
    }
  };

  const checkRegistration = async (id:string) => {
    let res;
    try {
      const config = await getConfig();
      res = await axios.get(`${RegisterAPI}${id}`, config);
    } catch (e) {
      return e;
    }
    const organizationData = res.data;
    const newName = organizationData.name.toLowerCase()
      .split(' ')
      .map((s: string) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');
    setName(newName);
    if (organizationData.order !== null) setOrder(organizationData.order);
    return true;
  };

  useEffect(() => {
    const urlPath = window.location.pathname;
    const id = urlPath.substring(6);
    checkRegistration(id);
  }, []);

  const backToSearchBtn = () => (
    <div className='row mt-2'>
      <div className='col'>
        <h1>
          Register 
          {' '}
          {name}
        </h1>
      </div>
      <div className='col d-flex justify-content-end'>
        <button
          style={{ height: '50px' }}
          className='btn btn-primary'
          type='button'
          onClick={() => history.push('/organizations')}
        >
          Back to Search
        </button>
      </div>
    </div>
  );

  const renderMessage = () => {
    if (messageType === 'success') {
      return (
        <div className='alert alert-success text-center mt-2' role='alert'>
          {statusMessage}
        </div>
      );
    } if (messageType === 'err') {
      return ( 
        <div className='alert alert-danger text-center mt-2' role='alert'>
          {statusMessage}
        </div>
      );
    }
    return null;
  };

  if (order !== 0) {
    return (
      <div className='full-height container'>
        <div className='row mt-2'>
          <div className='col'>
            <h1>
              {name}
              {' '}
              is already linked
            </h1>
          </div>
          <div className='col d-flex justify-content-end'>
            <button
              style={{ height: '50px' }}
              className='btn btn-primary'
              type='button'
              onClick={() => history.push('/organizations')}
            >
              Back to Search
            </button>
          </div>
        </div>
      </div>
    );
  }
  if (createOrder) {
    return (
      <div>
        {backToSearchBtn()}
        <div className='alert alert-danger text-center mt-2' role='alert'>
          No order found. Please create new order before proceeding.
        </div>
        <Link className='btn btn-primary' to='/add-order'>Add Order</Link>
      </div>
    ); 
  }
  return (
    <div className='full-height container'>
      {backToSearchBtn()}
      { messageType.length && statusMessage.length ? renderMessage() : null }
      <form>
        <div className='form-group'>
          <span>Order Number:</span>
          <input
            type='text'
            name='order_number'
            className='form-control'
            id='order_number'
            placeholder='Enter order number'
            value={incomingOrder}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setIncomingOrder(e.target.value)}
          />
        </div>
        <button
          disabled={!incomingOrder.replace(/\s+/g, '').length}
          className='btn btn-primary'
          type='submit'
          onClick={(e) => onSubmit(e, window.location.pathname)}
        >
          Link to order
        </button>
      </form>
    </div>
  );
};

export default LinkOrder;
